export default "__VITE_ASSET__DU$RkfGL__"